import type { BillingSubscription, ClubDetail } from '@repo/shared-types';

/** Amounts and the Suscripción tab are the owner's alone; the super admin gives support. */
export const canSeeSubscription = ({ viewerRole }: Pick<ClubDetail, 'viewerRole'>) =>
  viewerRole === 'OWNER' || viewerRole === 'SUPER_ADMIN';

/** A Mercado Pago debit that keeps charging: the only subscription the owner can cancel. */
export const hasDebitInForce = (current: BillingSubscription | null) =>
  current?.provider === 'MERCADOPAGO' &&
  (current.status === 'ACTIVE' || current.status === 'PAST_DUE');
